<template lang="pug">
.modal(:class="{'is-active': true}")
  .modal-background(@click="$emit('close')")
  .modal-card
    .modal-card-head
      p.modal-card-title Zoeken in {{goal.tree.title}} leerdoelen
      button.delete(@click="$emit('close')")
    .modal-card-body
      .field
        .control
          input.input(type="text" v-model="query" placeholder="zoek in doelen" :autofocus="'autofocus'")
      p {{suggestions.length}} {{'leerdoel' | pluralize(suggestions.length)}} gevonden  
      .suggestion(v-for="sug in suggestions" @click="$emit('select', sug)")
        .goal(v-if="sug.parent && sug.parent.title && sug.parent.parent" :style="{'background-color': sug.parent.color}") {{sug.parent.title}} 
        span {{sug.title}}
        div(v-if="sug.description") {{sug.description}}
</template>

<script>
import _ from 'lodash'

export default {
  props: ['goal'],
  data() {
    return {
      query: '',
      suggestions: []
    }
  },
  watch: {
    query(qq) {
      const q = qq.trim().toLowerCase()
      if (_.isEmpty(q)) {
        this.suggestions = []
        return
      }
      const allGoals = this.goal.rows
      const allText = _.map(allGoals, (g) => {
        return {
          text: g.title,
          goal: g
        }
      })
      _.each(allGoals, (g) => {
        if (g.description) {
          allText.push({
            text: g.description,
            goal: g
          })
        }
      })
      this.suggestions = _.uniq(_.map(_.take(
        _.filter(allText, (t) => t.text.toLowerCase().indexOf(q) > -1)
      , 10
      ), 'goal'))
      
    }
  },
  mounted() {
    let input = document.querySelector('[autofocus]');
    if (input) {
      input.focus()
    }
    
    window.addEventListener('keyup', (evt) => {
      if (event.keyCode == 27) {
        //escape
        this.$emit('close')
      }
    })
  }
}
</script>

<style scoped>
.modal-background {
  background-color: rgba(10,10,10,0.60)
}
.suggestion {
  margin-top: 8px;
  cursor: pointer;
}
.suggestion:hover {
  background-color: #efefef;
}
.goal {
  padding: 4px;
  border: 1px solid #666;
  border-radius: 4px;
  display: inline-block;
  margin-right: 4px;
}
</style>
